import TableRow from '@mui/material/TableRow';
import styled from 'styled-components';

export const HighlightableRow = styled(TableRow)`
  &:hover {
    background-color: rgba(25, 28, 29, 0.08);
    cursor: pointer;
  }
`;
